<template>
  <div class="container">
    <figure class="image is-128x128" style="margin: 0 auto">
      <img src="../assets/logo.svg" alt="Zegmento">
    </figure>
    <form v-on:submit.prevent="onSubmit">
      <div class="field">
        <div class="control">
          <input type="text"  class="input" value="Philadelphia" disabled>
        </div>
      </div>
      <div class="field">
        <div class="control">
          <input type="text"  class="input" value="Omaha" disabled>
<!--          <vue-google-autocomplete id="destination" classname="input" country="us" ref="to"-->
<!--                                   placeholder="Full destination address"-->
<!--                                   v-on:placechanged="getAddressData('to', $event)"-->
<!--                                   required>-->
<!--          </vue-google-autocomplete>-->
        </div>
      </div>
      <div class="columns">
        <!-- put padding-bottom here to avoid extra space between two datepickers -->
        <b-datepicker
          class="column"
          icon="calendar-today"
          :min-date="currentDate"
          placeholder="Click to select..."
          style="padding-bottom: 0"
          v-model="departDate"
          :mobileNative="false"
          required
        >
        </b-datepicker>
        <b-datepicker
          class="column"
          placeholder="Click to select..."
          icon="calendar-today"
          :min-date="departDate"
          v-model="returnDate"
          :mobileNative="false"
          :disabled="!departDate"
        >
        </b-datepicker>
      </div>
      <button type="submit" class="button is-warning" v-on:click="clear">Clear</button>
      <button type="submit" class="button is-primary" v-bind:class="{'is-loading': isLoading}">Search for Deals
      </button>
      <br><br>
      <span style="font-style: italic">Note: Zegmento currently only supports travel searches within the USA.</span>
      <br><br>

      <section class="hero is-warning">
        <div class="hero-body">
          <div class="container">
            <h1 class="title">
              This is a demo
            </h1>
            <h2 class="subtitle">
              All of the booking data is illegitimate, and you may experience a bug or two
            </h2>
          </div>
        </div>
      </section>
    </form>
  </div>
</template>

<script>
import VueGoogleAutocomplete from 'vue-google-autocomplete';
import axios from 'axios';
import format from 'date-fns/format';
import subDays from 'date-fns/sub_days';

export default {
  name: 'Search',
  data() {
    return {
      isLoading: false,
      // subtract one day to account for UTC
      currentDate: subDays(new Date(), 1),
      departDate: null,
      returnDate: null,
      flexibleDates: false,
      passengers: 1,
      fromLatitude: null,
      fromLongitude: null,
      fromLocality: "Philadelphia",
      toLatitude: null,
      toLongitude: null,
      toLocality: "Omaha",
    };
  },
  components: { VueGoogleAutocomplete },
  methods: {
    clear() {
      this.departDate = null;
      this.returnDate = null;
      this.$refs.from.clear();
      this.$refs.to.clear();
    },
    getAddressData(type, addressData, placeResultData, id) {
      if (type === 'from') {
        this.fromLatitude = addressData.latitude;
        this.fromLongitude = addressData.longitude;
        this.fromLocality = addressData.locality;
      } else {
        this.toLatitude = addressData.latitude;
        this.toLongitude = addressData.longitude;
        this.toLocality = addressData.locality;
      }
    },
    batchData() {
      if (this.returnDate) {
        return {
          num_passengers: this.passengers,
          depart_date: format(this.departDate, 'YYYY-MM-DD'),
          return_date: format(this.returnDate, 'YYYY-MM-DD'),
          from_lat: this.fromLatitude.toFixed(6),
          from_lon: this.fromLongitude.toFixed(6),
          to_lat: this.toLatitude.toFixed(6),
          to_lon: this.toLongitude.toFixed(6),
        };
      }
      return {
        num_passengers: this.passengers,
        depart_date: format(this.departDate, 'YYYY-MM-DD'),
        from_lat: this.fromLatitude.toFixed(6),
        from_lon: this.fromLongitude.toFixed(6),
        to_lat: this.toLatitude.toFixed(6),
        to_lon: this.toLongitude.toFixed(6),
      };
    },
    onSubmit(formData) {
      // need the following required fields
      if (this.fromLat !== null && this.toLat !== null && this.departDate) {
        this.isLoading = true;
        //        https://medium.com/@BjornKrols/tutorial-dynamic-content-via-url-query-parameters-in-vue-js-d2df19b66633
        const self = this;

        setTimeout(() => {
          self.isLoading = false;
          self.$router.push({
            path: `/fetch/${self.fromLocality}/${self.toLocality}/1`,
          });
        }, 1000);

        // axios.post('http://www.zegmentodemo.com:9999/search', this.batchData())
        //   .then((response) => {
        //
        //   })
        //   .catch((error) => {
        //     console.error(error);
        //     self.alertItineraryError();
        //     self.isLoading = false;
        //   });
      } else {
        this.alertEnterAllFields();
      }
    },
    alertItineraryError() {
      this.$dialog.alert({
        title: 'Error',
        message: 'Something went wrong.. please try again.',
        type: 'is-danger',
        hasIcon: true,
      });
    },
    alertEnterAllFields() {
      this.$dialog.alert({
        title: 'Error',
        message: 'Please make sure you fill all of the required fields.',
        type: 'is-danger',
        hasIcon: true,
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Search.vue